import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { WizardPrincipal } from './components/Wizard_Principal';
/*import { WizardPrincipal } from './components/WizardPrincipal';*/
import { Counter } from './components/Counter'; 
import { PrivateRoute } from './components/PrivateRoute';
import { authenticationService } from './services/authentication.service';
import { createBrowserHistory } from 'history';

import './custom.css'
import { AppContext } from './AppContext';
//import { customFetch } from './services/customFetch';
import CasClient, { constant } from "react-cas-client";

const CAS_SERVER = process.env.REACT_APP_CAS_SERVER;
const APP_ID = process.env.REACT_APP_ID;
const API_URL = process.env.REACT_APP_API_URL;

const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: 'https' };
const casClient = new CasClient(CAS_SERVER, casOptions);

const history = createBrowserHistory();

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
      
        this.state = {
            username: null,
            currentUser: null
        };
    }   

    componentDidMount() {
        //console.log("app state = " + JSON.stringify(this.state));
        const { username } = this.state;

        if (!username) {
            casClient
                .auth()
                .then(successRes => {
                  //console.log("App successRes = " + JSON.stringify(successRes)); this.setState({ username: successRes.user });
                  history.replace(successRes.currentPath);
                })
                .catch(errorRes => { console.log("App errorRes = " + JSON.stringify(errorRes)) });
        }
        //console.log("App componentDidMount");
        this.subscription = authenticationService.currentUser.subscribe(currentUser => {

            if (currentUser && currentUser.idpersona) {
                //console.log("App currentUser = " + JSON.stringify(currentUser));

                this.setState({ currentUser: currentUser });
                authenticationService.fetch();
            }
        });
        //customFetch.fetch(this.state.currentUser ? this.state.currentUser.token : null);
    }

    componentDidUpdate() {
        const { username, currentUser } = this.state;
        if (username && !currentUser) {
            fetch(API_URL + "Login", {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ idapp: APP_ID, netid: username })
            })
           // fetch(API_URL + "Login", { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ idapp: APP_ID, netid: username }) })
                .then(response => response.json())
                .then((result) => {
                    //console.log("RESPONSE LOGINNNNNN", result)
                    const currentUser = {
                        idpersona: result.user.idpersona,
                        usuario: result.user.netId,
                        identificacion: result.user.numeroidentificacion,
                        apellidos: result.user.apellidos,
                        nombres: result.user.nombres,
                        roles: ["PROFESOR"],
                        token: result.token
                    };
                    this.setState({ currentUser: currentUser });
                    authenticationService.login(currentUser);
                });
        }
    }

    componentWillUnmount() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    render() {
        //console.log("app state = " + JSON.stringify(this.state));

        //console.log("App render currentUser = " + JSON.stringify(this.state.currentUser));
        return (
            <AppContext.Provider value={ this.state.currentUser }>
                <Layout>
                    <PrivateRoute exact path='/' component={WizardPrincipal} />
                    {/*<PrivateRoute path='/validacion/' component={WizardPrincipal} />*/}
                    {/* <PrivateRoute path='/validacion-cas/' component={WizardPrincipal} roles={['PROFESOR']} /> */} 
                    <Route path='/logout' component={() => {
                        casClient.logout();
                        return null;
                    }} />
                    {/*<PrivateRoute exact path='/' component={Home} />*/}
                </Layout>
            </AppContext.Provider>
        );
    }
}
